import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectSelectedCurrency } from '../../store/user';
import ShowCurrencies from '../../utils/showCurrencies';
import SelectCurrency from '../../components/general/selectCurrency';
import ReactSelect from 'react-select';
// import ConvertUSD from "../../utils/convertUSD";
import useHandleAddProduct from '../../utils/handleAddProduct';
import { selectProducts } from '../../store/products';
import ConvertAUD from '../../utils/convertAUD';

const styles = {
  control: base => ({
    ...base,
    height: '48px',
    border: 'none',
    boxShadow: '0px 0px 5px 0px rgba(0, 0, 0, 0.10)',
  }),
  menuList: base => ({
    ...base,
    '::-webkit-scrollbar': {
      width: '6px',
      height: '0px',
    },
    '::-webkit-scrollbar-track': {
      background: '#f1f1f1',
    },
    '::-webkit-scrollbar-thumb': {
      background: '#888',
    },
    '::-webkit-scrollbar-thumb:hover': {
      background: '#555',
    },
  }),
  shadow: {
    boxShadow: '0px 0px 5px 0px rgba(0, 0, 0, 0.10)',
  },
};

const OrphanWidget = props => {
  /* ----------------------------- Start variables ---------------------------- */
  const { className } = props;
  const selectedCurrencyStore = useSelector(selectSelectedCurrency);
  const [productAmount, setProductAmount] = useState('');
  const [currentCurrency, setCurrentCurrency] = useState();
  const [isLoaded, setIsLoaded] = useState(false);
  const products = useSelector(state => selectProducts(state));
  const [addProduct] = useHandleAddProduct();
  const [orphanProduct, setOrphanProduct] = useState();
  /* -------------------------------------------------------------------------- */

  /* ------------------------------ Start methods ----------------------------- */
  const getAllProducts = () => {
    setIsLoaded(true);
    products.map(item => {
      item.sub_categories.map(inner_item => {
        inner_item.products.map(inner_item_product => {
          if (inner_item.name === 'Education') {
            if (inner_item_product.creator === 'MKD-GEN-MED-2023-01-122') setOrphanProduct(inner_item_product); // General Orphan Support
          }
          return inner_item_product;
        });
        return inner_item;
      });
      return item;
    });
  };
  const handleConvert = (currency, value) => {
    // console.log("handle convert",Math.round(ConvertAUD(currency, value, false)))
    // return Math.round(ConvertUSD(currency, value, false))
    return Math.round(ConvertAUD(currency, value, false));
  };
  const handleCurrency = currency => {
    setCurrentCurrency(currency.value);
  };
  const handleSelectedItem = (currency, value, index) => {
    let tempSelectedPrice = {};
    tempSelectedPrice.index = index;
    tempSelectedPrice.value = handleConvert(currency, value);
    tempSelectedPrice.label = (
      <span className="inline-block">
        Support {value / 50} {value / 50 > 1 ? 'children' : 'child'} {ShowCurrencies(currency, handleConvert(currency, value), false)}{' '}
        {<span className={'uppercase ml-1 text-base'}>{currency}</span>}
      </span>
    );
    setSelectedPrice(tempSelectedPrice);
  };
  const handleProductAmount = (currency, value) => {
    setProductAmount(handleConvert(currency, value));
  };
  const handleAddNewProduct = () => {
    let tempProduct = orphanProduct;
    let customAmount = Number(productAmount) ? Number(productAmount) : Number(selectedPrice.value) ? Number(selectedPrice.value) : 100;
    tempProduct = Object.assign({}, tempProduct, {
      quantity: customAmount,
    });
    addProduct({ product: tempProduct, currency: currentCurrency });
  };
  const [selectedPrice, setSelectedPrice] = useState({
    value: handleConvert(currentCurrency, 50),
    label: (
      <span className="inline-block">
        Support 1 child {ShowCurrencies(currentCurrency, handleConvert(currentCurrency, 50), false)}{' '}
        {<span className={'uppercase ml-1 text-base'}>{currentCurrency}</span>}
      </span>
    ),
    index: 1,
  });
  const suggestedPrices = [
    {
      value: handleConvert(currentCurrency, 50),
      label: (
        <span className="inline-block">
          Support 1 child {ShowCurrencies(currentCurrency, handleConvert(currentCurrency, 50), false)}{' '}
          {<span className={'uppercase ml-1 text-base'}>{currentCurrency}</span>}
        </span>
      ),
    },
    {
      value: handleConvert(currentCurrency, 100),
      label: (
        <span className="inline-block">
          Support 2 children {ShowCurrencies(currentCurrency, handleConvert(currentCurrency, 100), false)}{' '}
          {<span className={'uppercase ml-1 text-base'}>{currentCurrency}</span>}
        </span>
      ),
    },
    {
      value: handleConvert(currentCurrency, 150),
      label: (
        <span className="inline-block">
          Support 3 children {ShowCurrencies(currentCurrency, handleConvert(currentCurrency, 150), false)}{' '}
          {<span className={'uppercase ml-1 text-base'}>{currentCurrency}</span>}
        </span>
      ),
    },
    {
      value: handleConvert(currentCurrency, 200),
      label: (
        <span className="inline-block">
          Support 4 children {ShowCurrencies(currentCurrency, handleConvert(currentCurrency, 200), false)}{' '}
          {<span className={'uppercase ml-1 text-base'}>{currentCurrency}</span>}
        </span>
      ),
    },
  ];
  /* -------------------------------------------------------------------------- */

  /* ------------------------------- Start hooks ------------------------------ */
  useEffect(() => {
    if (selectedCurrencyStore) {
      setCurrentCurrency(selectedCurrencyStore);
      // handle-SelectedItem(selectedCurrencyStore, selectedPrice.index * 50, selectedPrice.index)
      if (selectedPrice) {
        handleSelectedItem(selectedCurrencyStore, selectedPrice.index * 50, selectedPrice.index);
      } else {
        handleProductAmount(selectedCurrencyStore, productAmount);
      }
      // selectedPrice
      // ? handleSelectedItem(selectedCurrencyStore, selectedPrice.index * 50, selectedPrice.index)
      // : handleProductAmount(selectedCurrencyStore, productAmount)
    } else {
      setCurrentCurrency('AUD');
      handleSelectedItem('AUD', selectedPrice.index * 50, selectedPrice.index);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCurrencyStore]);
  useEffect(() => {
    products.length && !isLoaded && getAllProducts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [products]);
  /* -------------------------------------------------------------------------- */
  return (
    <div className={`w-full rounded-lg bg-slate-200- h-[400px]- py-2 md:py-4 flex flex-wrap items-center ${className}`}>
      {/* <h1 className="basis-full h-12- text-[#253B7E] text-2xl md:text-3xl lg:text-4xl font-medium mb-4 md:mb-8">$150 worth of school supplies</h1> */}
      <div className="basis-full grid grid-cols-12 gap-2">
        <div className="col-span-12 mb-2 lg:mb-8 md:hidden">
          <ReactSelect
            options={suggestedPrices}
            className="max-h-[48px]- [&>*]:!cursor-pointer w-full border border-red-500"
            classNamePrefix={'orphan-widget'}
            value={selectedPrice}
            isSearchable={false}
            // styles={styles}
            onChange={e => {
              // console.log("value change", e, e.value)
              // setSelectedPrice(e);
              let tempVal = 0;
              suggestedPrices.map((item, index) => {
                if (item.value === e.value) {
                  tempVal = (index + 1) * 50;
                  handleSelectedItem(currentCurrency, tempVal, ++index);
                  setProductAmount('');
                }
                return item;
              });
              // setSelectedPrice({...selectedPrice, value: e.value, index:});
            }}
          />
        </div>
        <div className="col-span-12 md:grid grid-cols-12 gap-2 mb-2 lg:mb-8 hidden">
          {suggestedPrices.map((item, index) => {
            // console.log("suggestedPrices=",item.value,selectedPrice && selectedPrice.value)
            return (
              <div key={`prices${index}`} className="col-span-12 sm:col-span-6 xl:col-span-3">
                <div
                  className={`h-12- text-lg md:text-xl transition-all duration-200 cursor-pointer flex justify-center items-center px-2 md:px-4 py-2 md:py-4 min-w-[80px] border border-[#F60362] ${
                    selectedPrice && selectedPrice.value === handleConvert(currentCurrency, (index + 1) * 50)
                      ? 'bg-[#F60362] text-white'
                      : 'bg-white text-[#F60362] hover:bg-[#F60362] hover:text-white'
                  }`}
                  onClick={() => {
                    let tempVal = (index + 1) * 50;
                    // console.log("tempVal", tempVal)
                    handleSelectedItem(currentCurrency, tempVal, ++index);
                    setProductAmount('');
                  }}
                >
                  Support {index + 1} {index > 0 ? 'children' : 'child'} {ShowCurrencies(currentCurrency, item.value, false)}
                  <span className={`uppercase ml-1 text-base`}>{currentCurrency}</span>
                </div>
              </div>
            );
          })}
        </div>
        <div className="col-span-12 min-[400px]:col-span-6 lg:col-span-3 flex items-center justify-center" style={styles.shadow}>
          <SelectCurrency onChangeCurrency={e => handleCurrency(e)} classNamePrefix="orphan_select" />
        </div>
        <div
          className="col-span-12 min-[400px]:col-span-6 lg:col-span-6 flex justify-center items-center bg-white rounded-md h-14 px-2 mb-2 min-[400px]:mb-0"
          style={styles.shadow}
        >
          <span className="text-sm border-r pr-2 text-[#78716C]">{currentCurrency}</span>
          <input
            value={productAmount}
            className="w-full p-2 rounded-lg text-base focus:outline-none focus:ring-1 focus:ring-transparent focus:border-transparent"
            type="number"
            onChange={e => {
              setProductAmount(e.target.value);
              setSelectedPrice(null);
            }}
            placeholder="Enter amount"
          />
        </div>
        <div className="col-span-12 lg:col-span-3 flex justify-center items-center">
          <button
            className={`text-white w-full text-sm md:text-lg transition-all duration-200 flex items-center justify-center h-14 px-3 bg-[#f60362]`}
            onClick={e => {
              handleAddNewProduct();
            }}
          >
            Quick Donate
          </button>
        </div>
        <div className="col-span-12 flex items-center mt-4 md:mt-8">
          <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M11.8672 15.1875C11.8672 15.3429 11.8055 15.4919 11.6956 15.6018C11.5857 15.7117 11.4367 15.7734 11.2813 15.7734C10.9187 15.7734 10.5709 15.6294 10.3145 15.373C10.0581 15.1166 9.91407 14.7689 9.91407 14.4062V10.5C9.91407 10.4482 9.89349 10.3985 9.85686 10.3619C9.82023 10.3253 9.77055 10.3047 9.71875 10.3047C9.56335 10.3047 9.41432 10.243 9.30443 10.1331C9.19455 10.0232 9.13282 9.87415 9.13282 9.71875C9.13282 9.56335 9.19455 9.41431 9.30443 9.30443C9.41432 9.19455 9.56335 9.13281 9.71875 9.13281C10.0814 9.13281 10.4291 9.27685 10.6855 9.53325C10.9419 9.78965 11.0859 10.1374 11.0859 10.5V14.4062C11.0859 14.458 11.1065 14.5077 11.1431 14.5444C11.1798 14.581 11.2295 14.6016 11.2813 14.6016C11.4367 14.6016 11.5857 14.6633 11.6956 14.7732C11.8055 14.8831 11.8672 15.0321 11.8672 15.1875ZM10.1094 7.17969C10.3025 7.17969 10.4913 7.12241 10.6519 7.01511C10.8125 6.9078 10.9377 6.75528 11.0116 6.57684C11.0855 6.3984 11.1049 6.20204 11.0672 6.01261C11.0295 5.82317 10.9365 5.64917 10.7999 5.51259C10.6633 5.37602 10.4893 5.28301 10.2999 5.24533C10.1105 5.20765 9.91411 5.22699 9.73567 5.3009C9.55722 5.37481 9.4047 5.49998 9.2974 5.66058C9.19009 5.82117 9.13282 6.00998 9.13282 6.20312C9.13282 6.46213 9.2357 6.71052 9.41885 6.89366C9.60199 7.0768 9.85038 7.17969 10.1094 7.17969ZM20.4609 10.5C20.4609 12.4701 19.8767 14.3959 18.7822 16.034C17.6877 17.6721 16.132 18.9488 14.3119 19.7027C12.4918 20.4566 10.489 20.6539 8.55672 20.2695C6.62449 19.8852 4.84962 18.9365 3.45656 17.5434C2.0635 16.1504 1.11481 14.3755 0.730464 12.4433C0.346119 10.5111 0.543378 8.50824 1.2973 6.68811C2.05122 4.86799 3.32794 3.3123 4.966 2.21778C6.60407 1.12326 8.52992 0.539063 10.5 0.539062C13.1409 0.542164 15.6727 1.59261 17.54 3.45998C19.4074 5.32735 20.4578 7.85915 20.4609 10.5ZM19.2891 10.5C19.2891 8.76169 18.7736 7.06241 17.8078 5.61706C16.8421 4.1717 15.4694 3.04519 13.8634 2.37996C12.2574 1.71474 10.4903 1.54069 8.78534 1.87982C7.08043 2.21894 5.51437 3.05602 4.2852 4.28519C3.05603 5.51437 2.21895 7.08043 1.87982 8.78534C1.54069 10.4903 1.71475 12.2574 2.37997 13.8634C3.04519 15.4694 4.17171 16.8421 5.61706 17.8078C7.06242 18.7736 8.76169 19.2891 10.5 19.2891C12.8302 19.2865 15.0642 18.3597 16.712 16.712C18.3597 15.0642 19.2865 12.8302 19.2891 10.5Z"
              fill="#F60362"
            />
          </svg>
          <span className="ml-2">Give in honor of a loved one.</span>
        </div>
      </div>
    </div>
  );
};

export default OrphanWidget;
